import { useState, useEffect } from "react";
import { getAllCategories } from "../../../../../utils/categories";
import { getAllInstructors } from "../../../../../utils/liveClasses";

const useLiveClassFilters = () => {
  const [loading, setLoading] = useState(false);
  const [instructorOptions, setInstructorOptions] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});

  const statusOptions = [
    { id: "Live", label: "Live" },
    { id: "Not Started", label: "Not Started" },
    { id: "Completed", label: "Completed" },
  ];

  const [filterOptions, setFilterOptions] = useState({
    status: [],
    teachers: [],
    subjects: [],
  });

  // Fetch instructors
  const getInstructors = async () => {
    try {
      const response = await getAllInstructors();
      const instructorOptions = response?.data?.users?.map((user) => ({
        id: user._id,
        label: user?.fullName,
      }));
      setInstructorOptions(instructorOptions);
    } catch (error) {
      console.error("Error fetching instructors:", error.message);
    }
  };

  // Fetch categories
  const getCategories = async () => {
    try {
      setLoading(true);
      const response = await getAllCategories();
      const categoriesData = response?.data?.categories;
      const categoryOptions = categoriesData.map((categ) => ({
        id: categ._id,
        label: categ.name,
      }));
      setCategoriesOptions(categoryOptions);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching categories:", error.message);
    }
  };

  // Update filter options when instructor or categories options change
  useEffect(() => {
    setFilterOptions((prevState) => ({
      ...prevState,
      status: statusOptions,
      teachers: instructorOptions,
      subjects: categoriesOptions,
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instructorOptions, categoriesOptions]);

  // Fetch filter data on component mount
  useEffect(() => {
    getInstructors();
    getCategories();
  }, []);

  return {
    loading,
    filterOptions,
    selectedFilters,
    setSelectedFilters,
  };
};

export default useLiveClassFilters;
